import { render, staticRenderFns } from "./CrudUnity.vue?vue&type=template&id=e803caba&scoped=true&"
import script from "./CrudUnity.vue?vue&type=script&lang=js&"
export * from "./CrudUnity.vue?vue&type=script&lang=js&"
import style0 from "./CrudUnity.vue?vue&type=style&index=0&id=e803caba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e803caba",
  null
  
)

export default component.exports